module.exports = __webpack_public_path__ + "media/images/how_it_works_animation-f82a1903280d809f39cf987230230308.svg";